/**
 * Copyright IBM Corp. 2022, 2026
 */

import { PropsWithChildren } from 'react'
import {
	Layout as MDSLayout,
	normalizeLayoutProps,
} from '@hashicorp/mds-react/patterns'
import { vercelSplit } from '@web/cms'
import { type LayoutFieldsFragment } from 'types/dato'

interface LayoutProps extends PropsWithChildren {
	className?: string
	layout?: LayoutFieldsFragment
}

export const normalizeDatoLayout = (layout?: LayoutFieldsFragment) => {
	return normalizeLayoutProps.with({ transform: vercelSplit })({
		appearance: layout?.appearance,
		background: layout?.background,
		paddingTop: layout?.paddingTop,
		paddingBottom: layout?.paddingBottom,
	})
}

export const Layout = ({ layout, className, children }: LayoutProps) => {
	return (
		<MDSLayout {...normalizeDatoLayout(layout)} className={className}>
			{children}
		</MDSLayout>
	)
}
